export default __webpack_public_path__ + "static/media/09AW2JAN66.dca502a9.jpg";